import React, { useEffect, useState } from "react";
import DocumentType from "./DocumentType";
import DocumentCreation from "./DocumentCreation";
import "./newInterchangeStyles.css";
import Processes from "./Processes";
import TaskList from "./TaskList/TaskList";
import Signature from "./Signature";
import Preview from "./Preview";
import Confirm from "../../Components/confirm";
import GeneralDetails from "./GeneralDetails";
import { Events } from "../Languages/Events";
import EquipmentCreation from "./EquipmentCreation";

export const InterchangeApp = () => {
  const [view, setView] = useState("");
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  useEffect(() => {
    setView("Document Type")
    setSelectedIndex(0)
    document.addEventListener(Events.SWITCH_CUSTOMER_EVENT, onSwitchCustomer);
    return () => {
        document.removeEventListener(Events.SWITCH_CUSTOMER_EVENT, onSwitchCustomer);
    }
  }, []);

  let onSwitchCustomer = () => {
      Events.dispatchBreadCrumbEvent();
  }

  const menu = [
    "Document Type",
    "Document Creation",
    "Processes",
    "Task List",
    "Equipment Creation",
    "General Details",
    // "Templates",
  ];
  const unSavedChanges = (isChanges:any) => {
      setHasUnsavedChanges(isChanges);
  }

  const handleMenuClick = (index: number, item: string) => {
    if (hasUnsavedChanges) {
      Confirm.show("Unsaved Changes", "You have unsaved changes. Do you want to discard them?", [
            {
              label: "Discard Changes",
              callback: function () {
                setHasUnsavedChanges(false);
                setView(item);
                setSelectedIndex(index);
              },
            },
            { label: "No" },
          ]);
    } else {
      setView(item);
      setSelectedIndex(index);
    }
  };

  const selectedItem = {
    borderLeft: "solid black 3px",
    fontWeight: 600,
    color: "#344054",
  };

  return (
    <div className="container new-interchange">
      {/* <div className="row" style={{height: "calc(100vh - 88px)"}}> */}
      <div className="row">
        <div className="col-sm-12 col-md-3 col-lg-3 col-xl-2 bg-white p-0 border-right">
          <div className="accordion" id="accordionExample">
            <ul className="sidebar-list m-0 py-2">
              {menu.map((item, index) => (
                <li
                  key={index}
                  onClick={() => handleMenuClick(index, item)}
                  style={selectedIndex === index ? selectedItem : {}}
                >
                 {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="col-sm-12 col-md-9 col-lg-9 col-xl-10 right-content p-4 pb-0 bg-white">
          {view === "Document Type" && (
            <DocumentType unSavedChanges={unSavedChanges} />
          )}
          {view === "Document Creation" && <DocumentCreation unSavedChanges={unSavedChanges} />}
          {view === "Processes" && <Processes  unSavedChanges={unSavedChanges} />}
          {view === "Task List" && <TaskList />}
          {view === "Signature Capture" && <Signature unSavedChanges={unSavedChanges} />}
          {view === "General Details" && <GeneralDetails unSavedChanges={unSavedChanges} />}
          {view === "Equipment Creation" && <EquipmentCreation unSavedChanges={unSavedChanges} />}
          {view === "Pre Defined Templates" && <Preview  />}
        </div>
      </div>
    </div>
  );
};
